import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const menu = css`
  .blog {
    margin: ${rem(8)};
  }
`

export const styles = {
  menu,
}
